<template>
    <div  class=" tw-border-0 summaryContainer tw-z-[10] " >
    <div v-if="loaderVariable" class="onLoadingData mt-3">
        Loading...
    </div>
    <div v-else class="text-danger d-flex justify-content-center border border-danger rounded  tw-w-100 noData">
        {{ message || "No Data!" }}
    </div>
    </div>
</template>
<script >
export default{
    name:'noData',
    props:['loaderVariable','message']
}
</script>